import React, {Component} from 'react';
import {Row, Col, Image} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import { Menu } from 'antd';

import 'antd/dist/antd.css';

const SubMenu = Menu.SubMenu;

export default class Sidebar extends Component {
  handleClick(e) {
    if(e.key === 'manage-organisations') this.gotoPage('/manage-swayam');
    else if(e.key === 'manage-payments') this.gotoPage('/manage-payments');
  }

  gotoPage(page) {
    window.location.pathname = page;
  }

  render() {
    let defaultOpenKeys = [];

    return (
      <div className="sidebar">
        <div className="user-section">
          <Row className="user-detail-row">
            <Col md={12} className="user-avatar">
              <Link to={'/'} id="2">
                <Image src="/images/le.png" height="80" />
              </Link>
            </Col>
            <Col md={12} className="user-details">
              {this.props.ngo}
            </Col>
          </Row>
        </div>

        <div className="main-sidebar-sec">
          <Row>
            <div className="main-menus">
              <Menu className="sidebar-menu-options" onClick={this.handleClick.bind(this)}
                mode="inline" defaultSelectedKeys={this.props.selected} defaultOpenKeys={[this.props.openKey]}>

                <SubMenu key="manage-swayam" title={<div className="sidebar-submenu-title"><i className="fa fa-desktop sidebar-menu-item-icons"></i><span>Manage Swayam</span></div>}
                  className={this.props.selected.indexOf('manage-swayam') > -1 ? "sidebar-submenu sidebar-menu-items ant-menu-item-selected" : "sidebar-submenu sidebar-menu-items"}>
                  <Menu.Item key="manage-organisations" className="sidebar-menu-items">
                    <i className="fa fa-desktop sidebar-menu-item-icons"></i>
                    <span>Manage Organisations</span>
                  </Menu.Item>

                  <Menu.Item key="manage-payments" className="sidebar-menu-items">
                    <i className="fa fa-desktop sidebar-menu-item-icons"></i>
                    <span>Manage Payments</span>
                  </Menu.Item>
                </SubMenu>


              </Menu>
            </div>
          </Row>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Headers/Sidebar.js